import styled from 'styled-components';

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 15%;
`;

export default LoaderWrapper;
